var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideoCamera = function SvgVideoCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.506 2H1.494C.669 2 0 2.669 0 3.494v9.012C0 13.331.669 14 1.494 14h9.012c.825 0 1.494-.669 1.494-1.494V3.494C12 2.669 11.331 2 10.506 2zm5.919 1.178L13 5.541v4.918l3.425 2.36c.662.456 1.575-.01 1.575-.807V3.984c0-.793-.91-1.262-1.575-.806z"
  })));
};
export default SvgVideoCamera;